// extracted by mini-css-extract-plugin
export default {"commentsContainer":"CommentsView_commentsContainer__rGtpt","commentsContainerPc":"CommentsView_commentsContainerPc__hOPC3","textarea":"CommentsView_textarea__uscDK"};